// extracted by mini-css-extract-plugin
export default {"root":"demo_root__c7+zb","title":"demo_title__8e4VK","col":"demo_col__hcUsH","name":"demo_name__gLv4J"};